export { formatUsd } from '@rydres/shared';

export const fmtDateTime = (iso: string | null | undefined, tz?: string) =>
  iso
    ? new Date(iso).toLocaleString('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        ...(tz ? { timeZone: tz } : {}),
      })
    : '—';

export const fmtDate = (iso: string | null | undefined, tz?: string) =>
  iso
    ? new Date(iso).toLocaleDateString('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        ...(tz ? { timeZone: tz } : {}),
      })
    : '—';

export const fmtTime = (iso: string | null | undefined, tz?: string) =>
  iso
    ? new Date(iso).toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        ...(tz ? { timeZone: tz } : {}),
      })
    : '—';

/** "(714) 555-0100" for US numbers, otherwise the number as given. */
export const fmtPhone = (e164: string | null | undefined) => {
  if (!e164) return '—';
  const m = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(e164);
  return m ? `(${m[1]}) ${m[2]}-${m[3]}` : e164;
};

export const toE164 = (input: string): string | null => {
  const d = input.replace(/\D/g, '');
  if (d.length === 10) return `+1${d}`;
  if (d.length === 11 && d.startsWith('1')) return `+${d}`;
  return input.trim().startsWith('+') && d.length >= 8 ? `+${d}` : null;
};
